<template>
  <v-row v-if="form.level !== undefined && selectedLevel === form.level">
    <v-divider class="border-opacity-75"></v-divider>
    <v-col cols="2" v-for="index in [0, 1, 2, 3]" :key="`m_${form.level}_${index}`" align="center">
       <v-card elevation="4" class="rounded-xl"  max-width="270">
        <v-form
            :id="`kpi_m_${form.level}_${index}_input`"
            :label="getLabel(index)"
            :label-for="`kpi_m_${form.level}_${index}`"
            :style="`background: ${getColor(index)}`"
            class="likert-input"
        >
          <v-text-field
              :id="`kpi_m_${form.level}_${index}`"
              v-model="form[`m${index}`]"
              type="number"
              :label="getLabel(index)"
              step="0.001"
              min="0.00"
              max="1000000.00"
              required
          ></v-text-field>
        </v-form>
       </v-card>
    </v-col>

    <v-col cols="2">
      <v-card elevation="4" class="rounded-xl" max-width="270" >
        <v-form
            :id="`kpi_m_${form.level}_${4}_input`"
            :label="getLabel(4)"
            :label-for="`kpi_m_${form.level}_${4}`"
            :style="`background: ${getColor(4)};`"
            class="likert-input"
        >
          <v-text-field
              :id="`kpi_m_${form.level}_${4}`"
              v-model="m4"
              :value="m4"
              :label="getLabel(4)"
              readonly
          ></v-text-field>
        </v-form>
      </v-card>
    </v-col>
    <v-divider class="border-opacity-75"></v-divider>
    <v-col cols="12" >
      <div v-if="monotonous === 'error'" style="color: red">Wrong margins</div>

      <MarginsDistributionPlot
          v-if="monotonous === 'asc' || monotonous === 'desc'"
          :values="[form.m0, form.m1, form.m2, form.m3]"
      ></MarginsDistributionPlot>

      <span v-else>The distribution plot will be generated after you have given all margin inputs.</span>
    </v-col>
  </v-row>
</template>

<script setup>
import MarginsDistributionPlot from "../../../Shared/MarginsDistributionPlot.vue";
import MyUtils from "../../../Mixins/Utils"
import {computed} from "vue";

const props = defineProps({
  // form.kpi.kpi_margins_attributes[index]
  value: {
    type: Object,
    required: true
  },
  selectedLevel: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['input'])
const form = computed({get() {
    return props.value
  },set(val){
    emit('input', val)
  }
})

const m4 = computed(()=>{
  if(monotonous.value === 'asc') return `>=${form.value.m3}`
  else if (monotonous.value === 'desc') return `<= ${form.value.m3}`
  else return null
})

const monotonous = computed(()=>{
  const kpi = form.value
  return MyUtils.methods.isMonotonic([kpi.m0, kpi.m1, kpi.m2, kpi.m3])
})

function getLabel(index){
  if (index === 0)
    return 'Failed'
  else if (index === 1)
    return 'Underachieved'
  else if (index === 2)
    return 'Achieved'
  else if (index === 3)
    return 'Overachieved'
  else
    return 'Excelled'
}

function getColor(index) {
  switch (index) {
    case 0:
      return '#ff7171';
    case 1:
      return '#ffb673';
    case 2:
      return '#e2ff73';
    case 3:
      return '#93ff5eb2';
    default:
      return '#30cf00';
  }
}

const margins = ["Failed", "Underachieved", "Achieved", "Overachieved"]
</script>

<style scoped>

</style>